import { subscribe } from '../../common/errors/sagas';
import { notificationError } from '../../common/errors/notificationTypes';

const pre = 'IMPACTANALYSIS/PRICINGPARAMETERS/';

export const ADD_PRICING_PARAMETERS_ROW = `${pre}ADD_PRICING_PARAMETERS_ROW`;
export const CSV_EXPORT_EMPTY = `${pre}CSV_EXPORT_EMPTY`;
export const DELETE_PRICING_PARAMETERS_ROW = `${pre}DELETE_PRICING_PARAMETERS_ROW`;
export const FETCH_PRICING_PARAMETERS_MAPPINGS_FAILED = `${pre}FETCH_PRICING_PARAMETERS_MAPPINGS_FAILED`;
export const PRICING_PARAMETERS_LOADED = `${pre}PRICING_PARAMETERS_LOADED`;
export const TOGGLE_PRICING_PARAMETERS = `${pre}TOGGLE_PRICING_PARAMETERS`;
export const REMOVE_TOGGLE_PRICING_PARAMETERS = `${pre}REMOVE_TOGGLE_PRICING_PARAMETERS`;

export const REMOVE_ALL_ROWS = `${pre}REMOVE_ALL_ROWS`;
export const SET_CURRENCIES = `${pre}SET_CURRENCIES`;
export const SET_LOADING = `${pre}SET_LOADING`;
export const SET_PRICING_PARAMETERS_ROWS = `${pre}SET_PRICING_PARAMETERS_ROWS`;
export const SET_PRICING_PARAMETERS_INFO_LOADED = `${pre}SET_PRICING_PARAMETERS_INFO_LOADED`;
export const SET_ROW_MAPPINGS = `${pre}SET_ROW_MAPPINGS`;
export const SET_ACTIVE_VALUE = `${pre}SET_ACTIVE_VALUE`;
export const SAVE_AS_TEMPLATE = `${pre}SAVE_AS_TEMPLATE`;
export const SAVE_AS_TEMPLATE_FAILED = `${pre}SAVE_AS_TEMPLATE_FAILED`;
export const SET_TEMPLATES = `${pre}SET_TEMPLATES`;
export const DELETE_TEMPLATE = `${pre}DELETE_TEMPLATE`;
export const SELECT_TEMPLATE = `${pre}SELECT_TEMPLATE`;
export const LOAD_SELECTED_ROWS = `${pre}LOAD_SELECTED_ROWS`;
export const LOAD_SELECTED_ROWS_FAILED = `${pre}LOAD_SELECTED_ROWS_FAILED`;
export const SUBMIT_PRICING_PARAMETERS = `${pre}SUBMIT_PRICING_PARAMETERS`;
export const SUBMIT_PRICING_PARAMETERS_FAILED = `${pre}SUBMIT_PRICING_PARAMETERS_FAILED`;
export const DERIVE_AMOUNT_USD = `${pre}DERIVE_AMOUNT_USD`;
export const SET_FX_RATES = `${pre}SET_FX_RATES`;
export const SET_IM_MODEL_PRICING_PARAMS = `${pre}SET_IM_MODEL_PRICING_PARAMS`;
export const GET_DEFAULT_BUCKET = `${pre}GET_DEFAULT_BUCKET`;
export const GET_DEFAULT_BUCKET_FAILED = `${pre}GET_DEFAULT_BUCKET_FAILED`;
export const SET_FX_RATES_FAILED = `${pre}SET_FX_RATES_FAILED`;
export const VIEW_TRADE_IN_PRICING_PARAMS = `${pre}VIEW_TRADE_IN_PRICING_PARAMS`;
export const SET_TEMPLATE_SAVED = `${pre}SET_TEMPLATE_SAVED`;
export const SET_TEMPLATE_IN_PROCESS_OF_SAVING = `${pre}SET_TEMPLATE_IN_PROCESS_OF_SAVING`;
export const UPLOAD_TEMPLATE_ERROR = `${pre}UPLOAD_TEMPLATE_ERROR`;
export const SET_TEMPLATES_NAMES_LOADED = `${pre}SET_TEMPLATES_NAMES_LOADED`;
export const GET_TEMPLATES_NAMES_FAILED = `${pre}GET_TEMPLATES_NAMES_FAILED`;
export const SUBMIT_PRICING_PARAMETERS_INVALID = `${pre}SUBMIT_PRICING_PARAMETERS_INVALID`;
export const IMPORT_SENSITIVITIES = `${pre}IMPORT_SENSITIVITIES`;
export const IMPORT_SENSITIVITIES_FAILED = `${pre}IMPORT_SENSITIVITIES_FAILED`;
export const COPY_TRADE_ID = `${pre}COPY_TRADE_ID`;
export const COPY_TRADE_ID_FAILED = `${pre}COPY_TRADE_ID_FAILED`;

subscribe(CSV_EXPORT_EMPTY, 'Failed to export as CSV - no data', notificationError);
subscribe(FETCH_PRICING_PARAMETERS_MAPPINGS_FAILED, 'Failed to fetch pricing parameters mappings', notificationError);
subscribe(SAVE_AS_TEMPLATE_FAILED, 'Failed to save template', notificationError);
subscribe(SUBMIT_PRICING_PARAMETERS_FAILED, 'Failed to submit pricing parameters rows', notificationError);
subscribe(GET_DEFAULT_BUCKET_FAILED, 'Failed to fetch the default bucket', notificationError);
subscribe(LOAD_SELECTED_ROWS_FAILED, 'Failed to fetch data about the trade', notificationError);
subscribe(SET_FX_RATES_FAILED, 'Failed to fetch FX rates', notificationError);
subscribe(UPLOAD_TEMPLATE_ERROR, 'There was an error uploading the template', notificationError);
subscribe(GET_TEMPLATES_NAMES_FAILED, 'There was an error fetching the templates', notificationError);
subscribe(SUBMIT_PRICING_PARAMETERS_INVALID, 'Pricing Paramters Invalid', notificationError);
subscribe(COPY_TRADE_ID_FAILED, 'Copying the Trade ID failed - There must be at least one row.', notificationError);
subscribe(IMPORT_SENSITIVITIES_FAILED, 'There was an error importing sensitivities.', notificationError);

export const importSensitivitiesFailed = error => ({
    type: IMPORT_SENSITIVITIES_FAILED,
    error
});


export const copyTradeIdFailed = error => ({
    type: COPY_TRADE_ID_FAILED,
    error
});

export const copyTradeId = () => ({
    type: COPY_TRADE_ID
});

export const importSensitivities = file => ({
    type: IMPORT_SENSITIVITIES,
    file
});

export const togglePricingParameters = (imModel) => ({
    type: TOGGLE_PRICING_PARAMETERS, imModel
});


export const getDefaultBucketFailed = error => ({
    type: GET_DEFAULT_BUCKET_FAILED,
    error
});

export const getTemplatesNamesFailed = error => ({
    type: GET_TEMPLATES_NAMES_FAILED,
    error
});

export const getDefaultBucket = (risk, qualifier, rowId) => ({
    type: GET_DEFAULT_BUCKET,
    risk,
    qualifier,
    rowId
});

export const setTemplateInProcessOfSaving = inProcess => ({
    type: SET_TEMPLATE_IN_PROCESS_OF_SAVING,
    inProcess
});

export const setTemplatesNamesLoaded = names => ({
    type: SET_TEMPLATES_NAMES_LOADED,
    names
});

export const uploadTemplateError = error => ({
    type: UPLOAD_TEMPLATE_ERROR,
    error
});

export const deriveAmountUsd = (amount, currency, convertToUsd, rowId) => ({
    type: DERIVE_AMOUNT_USD,
    amount,
    currency,
    convertToUsd,
    rowId
});

export const viewTradeInPricingParams = (trade, readOnly) => ({
    type: VIEW_TRADE_IN_PRICING_PARAMS,
    trade,
    readOnly
});

export const setTemplateSaved = templateSaved => ({
    type: SET_TEMPLATE_SAVED,
    templateSaved
});

export const saveAsTemplate = (name, templateData) => ({
    type: SAVE_AS_TEMPLATE,
    name,
    templateData
});

export const setFxRatesfailed = error => ({
    type: SET_FX_RATES_FAILED,
    error
});

export const setFxRates = (rates, date) => ({
    type: SET_FX_RATES,
    rates,
    date
});

export const loadSelectedRowsFailed = error => ({
    type: LOAD_SELECTED_ROWS_FAILED,
    error
});

export const loadSelectedRows = rows => ({
    type: LOAD_SELECTED_ROWS,
    rows
});

export const setImMmodelPricingParams = params => ( {
    type: SET_IM_MODEL_PRICING_PARAMS,
    params
});

export const selectTemplate = templateId => ({
    type: SELECT_TEMPLATE,
    templateId
});

export const deleteTemplate = templateId => ({
    type: DELETE_TEMPLATE,
    templateId
});

export const setTemplates = templates => ({
    type: SET_TEMPLATES,
    templates
});

export const submitPricingParameters = data => ({
    type: SUBMIT_PRICING_PARAMETERS,
    data
});

export const setCurrencies = currencies => ({
    type: SET_CURRENCIES,
    currencies
});

export const setPricingParametersInfoLoaded = loaded => ({
    type: SET_PRICING_PARAMETERS_INFO_LOADED,
    loaded
});

export const setActiveValue = (key, value, rowId) => ({
    type: SET_ACTIVE_VALUE,
    key,
    value,
    rowId
});

export const submitPricingParametersInvalid = error => ({
    type: SUBMIT_PRICING_PARAMETERS_INVALID,
    error
});

export const submitPricingParametersFailed = error => ({
    type: SUBMIT_PRICING_PARAMETERS_FAILED,
    error
});

export const saveAsTemplateFailed = error => ({
    type: SAVE_AS_TEMPLATE_FAILED,
    error
});

export const fetchPricingParametersMappingsFailed = error => ({
    type: FETCH_PRICING_PARAMETERS_MAPPINGS_FAILED,
    error
});

export const setRowMappings = rowMappings => ({
    type: SET_ROW_MAPPINGS,
    rowMappings
});

export const pricingParametersLoaded = () => ({
    type: PRICING_PARAMETERS_LOADED
});

export const csvExportEmpty = error => ({
    type: CSV_EXPORT_EMPTY,
    error
});

export const addPricingParametersRow = () => ({
    type: ADD_PRICING_PARAMETERS_ROW
});

export const deletePricingParametersRow = id => ({
    type: DELETE_PRICING_PARAMETERS_ROW,
    id
});

export const removeAllRows = () => ({
    type: REMOVE_ALL_ROWS
});

export const removeTogglePricingParameters = () => ({
    type: REMOVE_TOGGLE_PRICING_PARAMETERS
});

export const setLoading = loading => ({
    type: SET_LOADING,
    loading
});

export const setPricingParametersRows = data => ({
    type: SET_PRICING_PARAMETERS_ROWS,
    data
});
